/**
 * m1v2-hero.js — prepare media, then start the desktop CSS intro together.
 * Desktop intro (typewriter / M grow / arm land / veil / copy) is CSS-only.
 */
(function () {
  var DESKTOP_MIN = 821;

  function prepareIntro(root) {
    var photo = root.querySelector('.m1v2-hero__photo');
    var imageReady = new Promise(function (resolve) {
      if (!photo) { resolve(false); return; }
      var timer = window.setTimeout(function () { finish(false); }, 4000);
      var finished = false;
      function finish(ready) {
        if (finished) return;
        finished = true;
        window.clearTimeout(timer);
        photo.removeEventListener('load', loaded);
        photo.removeEventListener('error', failed);
        resolve(ready);
      }
      function failed() { finish(false); }
      function loaded() {
        if (!photo.naturalWidth) { finish(false); return; }
        if (photo.decode) {
          photo.decode().then(function () { finish(true); }, function () { finish(false); });
        } else {
          finish(true);
        }
      }
      if (photo.complete) loaded();
      else {
        photo.addEventListener('load', loaded);
        photo.addEventListener('error', failed);
      }
    });
    // Explicitly request the animated headline font; hidden text may not load it.
    var type = root.querySelector('.m1v2-hero__type');
    var fontReady = document.fonts && type
      ? Promise.all([
          document.fonts.load('900 80px "Doto"', type.textContent),
          document.fonts.ready
        ]).then(function () { return true; }, function () { return false; })
      : Promise.resolve(true);
    var timeout;
    var prepared = Promise.all([imageReady, fontReady]);
    var bounded = new Promise(function (resolve) {
      timeout = window.setTimeout(function () { resolve([false]); }, 4000);
    });
    Promise.race([prepared, bounded]).then(function (ready) {
      window.clearTimeout(timeout);
      if (!root.isConnected) return;
      if (ready.some(function (value) { return !value; }) || shouldSkipMotion(root) || !isDesktop()) {
        root.classList.add('m1v2-hero--static');
        stampFcc(root, 0);
        return;
      }
      root.classList.add('m1v2-hero--ready');
    });
  }

  function isDesktop() {
    return window.matchMedia('(min-width: ' + DESKTOP_MIN + 'px)').matches;
  }

  function shouldSkipMotion(root) {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var design = typeof Shopify !== 'undefined' && Shopify.designMode;
    var mode = root.getAttribute('data-intro-mode') || 'static';
    return reduce || design || mode !== 'animated' || root.classList.contains('m1v2-hero--static');
  }

  function stampFcc(root, delay) {
    var stamp = root.querySelector('.fcc-stamp-hero[data-fcc-stamp]');
    if (!stamp || stamp.classList.contains('is-stamped')) return;
    if (!delay) {
      stamp.classList.add('is-stamped');
      return;
    }
    window.setTimeout(function () {
      stamp.classList.add('is-stamped');
    }, delay);
  }

  function init(root) {
    if (!root || root.dataset.m1v2HeroInit === '1') return;
    root.dataset.m1v2HeroInit = '1';

    root.addEventListener('animationend', function (event) {
      if (event.animationName === 'm1v2HeroCopyIn') {
        root.classList.add('m1v2-hero--landed');
        stampFcc(root, 0);
      }
    });

    if (shouldSkipMotion(root)) {
      root.classList.add('m1v2-hero--static');
      stampFcc(root, 0);
    } else if (isDesktop()) {
      prepareIntro(root);
    } else {
      stampFcc(root, 400);
    }
  }

  function boot() {
    document.querySelectorAll('[data-m1v2-hero]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    event.target.querySelectorAll('[data-m1v2-hero]').forEach(init);
    if (event.target.hasAttribute && event.target.hasAttribute('data-m1v2-hero')) {
      init(event.target);
    }
  });
})();
